import React from 'react';
import { gql } from '@apollo/client';
import { PinterestBoardController, PinterestBoardControllerProps } from './PinterestBoard.controller';

export type PinterestBoardApolloProps = {
  //
  socialProfile: PinterestBoardControllerProps['socialProfile'];
  useFormInstance: PinterestBoardControllerProps['useFormInstance'];
  pinterestBoardValue?: PinterestBoardControllerProps['pinterestBoardValue'];
  pinterestFormName: PinterestBoardControllerProps['pinterestFormName'];
  pinterestRules: PinterestBoardControllerProps['pinterestRules'];
  parentDropdownRef?: PinterestBoardControllerProps['parentDropdownRef'];
  isParentDropdownExpanded: PinterestBoardControllerProps['isParentDropdownExpanded'];
};

gql`
  mutation RefreshPinterestBoards($id: ID!) {
    refreshPinterestBoards(socialProfileId: $id) {
      id
      boards {
        ...CorePinterestBoardFields
      }
    }
  }
`;

export const PinterestBoardApollo = (props: PinterestBoardApolloProps): JSX.Element => {
  return <PinterestBoardController {...props} />;
};
